/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState,useContext } from 'react';
import AnimatedModel from './Animation/AnimatedModel';
import InputBox from './InputBox';
import DropdownWithSearch from './DropdownWithSearch';
import Dropdown from './Dropdown';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import UpdateButton from './UpdateButton';
import GlobalContext from './Context/GloablContext';
import { useSelector,useDispatch } from 'react-redux';
import { useEditOrganizationSubDivMutation ,useAddOrganizationMutation} from '../features/organizationSlice';
import { useOnClickOutside } from '../CommonMethods/OutsideClick';
import { validateEmail } from '../CommonMethods/EmailValidator';
import { addAllInitially, resetOrgList } from '../pages/ManageOrganizations/usersSlice';
import DropdownWithSearchForEdit from './DropdownWithSearchForEdit';
import ErrorMessage from './ErrorMessage';
import Toast from './Toast';
import { useParams } from 'react-router-dom';
import DropdownWithSearchForEditMonitor from '../pages/ManageOrganizations/DropdownsWithSearch/editDropdownSearchForMonitor';
import { addAllMonitorsInitially } from '../pages/ManageOrganizations/monitorsSlice';
import PhoneNumberValidator from './PhoneNumberInput';
import { phoneCodeArray } from '../CommonMethods/phoneNumberCountryCodes';
import DropdownWithSearchForEditProvider from '../pages/ManageOrganizations/DropdownsWithSearch/editDropdownSearchForProvider';
import { addAllProviderInitially } from '../pages/ManageOrganizations/providersSlice';

const EditSubDivModal = ({handleClose, buttonName, data,handleOnCLickActivate, loadingActivation,add,organization_id,setConfirmation}) => {
    
    const dispatch=useDispatch()
    const location=useLocation()
    const navigate=useNavigate()
    const {setToastmessage}=useContext(GlobalContext)
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const outsideClickRef = useRef();
    const {id}=useParams()
    const [editOrganizationSubDiv] = useEditOrganizationSubDivMutation()
    const [addOrganization] = useAddOrganizationMutation()
    const dataArr=useSelector(state=>state?.userSelect?.selectedUsers?.checkedArr?.[0])
    
    const monitorDataArr=useSelector(state=>state?.monitorsSelect?.selectedUsers?.checkedArr?.[0])
    const providerDataArr=useSelector(state=>state?.providersSelect?.selectedUsers?.checkedArr?.[0])
    const [emptyField,setEmptyField] = useState(false)
    const [submitSelected,setSubmitSeletected] = useState(false)
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true});
    const [loading,setLoading] = useState(false)
    const [toastErrorMessage,setToastErrorMessage] = useState('')
    const initialState={
        sub_div_name:'',sub_div_id:'',
        no_of_minutes:'',no_of_time_period:'',time_period:'Day(s)',
        no_of_readings:''
        ,no_of_time_period2:'',time_period2:'Day(s)',
        name:''
        ,email_addr:'',main_number:'',mobile_number:''

    }
    const [newSubDiv, setNewSubDiv] = useState(
        initialState
    );

    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')

   

    const sanitizeData = (data) => {
        const sanitizedData = {};
      
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
            // Check if the value is undefined or null, and replace with an empty string
                sanitizedData[key] = data[key] === undefined || data[key] === null ? '' : data[key];
            }
        }
      
        return sanitizedData;
    };
      

    function handleOnChangeInput(id,option) {
        setSubmitSeletected(false)
        setEmptyField(false)

        const fieldToUpdate = {
            sub_div_name:"sub_div_name",
            no_of_minutes:"no_of_minutes",
            no_of_time_period:"no_of_time_period",
            time_period:"time_period",
            no_of_readings:"no_of_readings",
            no_of_time_period2:"no_of_time_period2",
            time_period2:"time_period2",
            name:"name",
            email_addr:"email_addr",
            poc_main_number:"main_number",
            mobile_number:"mobile_number"
        }[id];
    
        const updatedNewSubDiv = {...newSubDiv};
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true
        if (id==="poc_main_number"||id==="mobile_number"||id==="no_of_minutes"||id==="no_of_time_period"||id==="no_of_readings"||id==="no_of_time_period2") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                updatedNewSubDiv[fieldToUpdate] = sanitizedOption   
                setNewSubDiv(updatedNewSubDiv)         
                return
            }
        }
        if(fieldToUpdate){
           
            if(fieldToUpdate==="poc_main_number"||fieldToUpdate==="mobile_number"||id==="no_of_minutes"||id==="no_of_time_period"||id==="no_of_readings"||id==="no_of_time_period2"){
                if(option?.length<=20){
                    updatedNewSubDiv[fieldToUpdate] = option 
                    
                }
            }
            else if(fieldToUpdate==="sub_div_name"){
                if(option?.length<=75){
                    updatedNewSubDiv[fieldToUpdate] = option
                }

            }
            else if(fieldToUpdate==="email_addr"){
                if(option?.length<=80){
                    updatedNewSubDiv[fieldToUpdate] = option.replace(/\s/g, '')
                }
            }
         
            else{
                updatedNewSubDiv[fieldToUpdate] = option
            }
                
            
        }
        setNewSubDiv(updatedNewSubDiv)


    }
    
    const handleOnClickEdit=async()=>{
        setSubmitSeletected(true)
        const hasEmptyFields = () => {
            return newSubDiv.sub_div_name.trim()===''
        };
        if (hasEmptyFields()) {
           
            setToastErrorMessage("Please fill in the mandatory field");
            return;
        }
        if ((!(isPhoneNumberValid.main_number)&&newSubDiv?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&newSubDiv?.mobile_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        function isEmailValid(){
            const isValidEmail=newSubDiv?.email_addr?.trim()!==""&&validateEmail(newSubDiv.email_addr)
           
            return isValidEmail
        }
        if(isEmailValid()){
            return

        }
        try{
            
            let body={
                "name": newSubDiv.sub_div_name,
                "organization_id":organization_id,
                "subdivision_id": newSubDiv.sub_div_id,
                "monitor_user_list": 
                    monitorDataArr,
                "corporate_users": 
                    dataArr,
                "provider_list": 
                providerDataArr,
                "point_of_contact_person": {
                    "name": newSubDiv?.name,
                    "poc_mobile_country_code": add&&countryCodeVal===""?"+91":"+"+((countryCodeVal2!==""||countryCodeVal2!==undefined)?countryCodeVal2?.split('\t')?.join(''):country_code?.split('\t')?.join('')),
                    "mobile_number": newSubDiv.mobile_number,
                    "email_address": newSubDiv.email_addr,
                    "poc_main_country_code": add&&countryCodeVal===""?"+91":"+"+((countryCodeVal!==""||countryCodeVal!==undefined)?countryCodeVal?.split('\t')?.join(''):country_code?.split('\t')?.join('')),
                    "main_number": newSubDiv.main_number
                },
                "wellness_timing": {
                    "number_of_minutes": newSubDiv.no_of_minutes,
                    "number_of_time_periods": newSubDiv.no_of_time_period,
                    "time_period": newSubDiv.time_period
                },
                "vital_collection_timing": {
                    "number_of_readings": newSubDiv.no_of_readings,
                    "number_of_time_periods": newSubDiv.no_of_time_period2,
                    "time_period": newSubDiv.time_period2
                }
              
            }
            if(add){
                setLoading(true)
                const addRes=await addOrganization({body,id})
                if(addRes?.error?.data?.message){
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                }
                else{
                    navigate(`/manage-organizations/${id}`,{state:location.state})
                    setToastmessage('Organization updated successfully');
                    setLoading(false)
                }


            }else{
                setLoading(true)
                const editRes=await editOrganizationSubDiv({id,body})
                if(editRes?.error?.data?.message){
                    setLoading(false)
                    setToastErrorMessage(editRes?.error?.data?.message)
                
                }
                else{
                    navigate(`/manage-organizations/${id}`,{state:location.state})
                    setToastmessage('Organization updated successfully')
                    setConfirmation(false)
                    setLoading(false)
                }

            }

        }catch(e){

        }

    }
    useEffect(()=>{
        if(data!==undefined&& !add){
            setNewSubDiv(sanitizeData({ sub_div_name: data?.name,sub_div_id:data?.subdivision_id,
                no_of_minutes:data?.wellness_timing?.number_of_minutes,no_of_time_period:data?.wellness_timing?.number_of_time_periods,time_period:data?.wellness_timing?.time_period,
                no_of_readings:data?.vital_collection_timing?.number_of_readings
                ,no_of_time_period2:data?.vital_collection_timing?.number_of_time_periods,time_period2:data?.vital_collection_timing?.time_period,
                name:data?.point_of_contact_person?.name
                ,email_addr:data?.point_of_contact_person?.email_address,main_number:data?.point_of_contact_person?.main_number,mobile_number:data?.point_of_contact_person?.mobile_number
            },))

            dispatch(addAllInitially([data?.corporate_users,true]))
            dispatch(addAllMonitorsInitially([data?.monitor_user_list,true]))
            dispatch(addAllProviderInitially([data?.provider_list,true]))
            setCountryCodeVal(data?.point_of_contact_person?.poc_main_country_code?.split('+')[1])
            setCountryCodeVal2(data?.point_of_contact_person?.poc_mobile_country_code?.split('+')[1])
        }
    },[data])
    
    return (
        <AnimatedModel 
            Children={
                <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                        <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                            <div className="flex justify-between py-[16px]">
                                <h1 className='text-2xl font-normal text-[#000]'>Sub Division details</h1>
                                <img onClick={()=>handleClose()} src='/images/close_icon.svg' className='cursor-pointer'/>
                            </div>  
                            <div className='max-h-[calc(100vh-300px)] overflow-x-hidden scrollbar_purple pr-2'>
                                <div className="relative">
                                    <div className='flex flex-wrap -mx-[18px]'>
                                        <div className='w-2/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"Sub Division Name*"} 
                                                    placeholder={"Enter Sub Division Name"}
                                                    id={"sub_div_name"}
                                                    htmlFor={"Admin_Username"}
                                                    value={newSubDiv?.sub_div_name}
                                                    emptyField={submitSelected&&newSubDiv?.sub_div_name.trim()===''}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>
                                        {data!==undefined&&<div className='w-1/3 px-[18px]  mb-5'>
                                            <div className='w-full'>
                                                <InputBox
                                                    label={"ID"} 
                                                    id={"org_id"}
                                                    htmlFor={"org_id"}
                                                    disabled={true}
                                                    value={newSubDiv?.sub_div_id}
                                                    emptyField={''}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>}
                                        
                                    </div> 
                                </div>
                                
                                <div className="">
                                    <div className='flex flex-wrap -mx-[18px]'>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <DropdownWithSearchForEdit
                                                    label={"Corporate Users"}
                                                    id={`corporate_users`}
                                                    placeholder={(dataArr?.length<1||dataArr===undefined)?'Select Corporate Users':`${dataArr?.length} Selected`}
                                                    disabled={false}
                                                    index={0}
                                                    value={''}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <DropdownWithSearchForEditProvider
                                                    label={"Providers"}
                                                    id={`Select_Providers`}
                                                    placeholder={(providerDataArr?.length<1||providerDataArr===undefined)?'Select Providers':`${providerDataArr?.length} Selected`}
                                                    disabled={false}
                                                    index={0}
                                                    value={''}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <DropdownWithSearchForEditMonitor
                                                    label={"Monitor Users"}
                                                    id={`monitor_users`}
                                                    placeholder={(monitorDataArr?.length<1||monitorDataArr===undefined)?'Select Monitor Users':`${monitorDataArr?.length} Selected`}
                                                    disabled={false}
                                                    index={0}
                                                    value={''}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h1 className="text-lg font-normal text-[#000000] mb-5">Wellness Information</h1>
                                    <div className='flex flex-wrap -mx-[18px]'>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox 
                                                    label={"Number of Minutes"} 
                                                    placeholder={"Enter No.of minutes"}
                                                    id={"no_of_minutes"}
                                                    htmlFor={"no_of_minutes"}
                                                    isUnit={true}
                                                    unitType={"Minutes"}
                                                    value={newSubDiv?.no_of_minutes}
                                                    emptyField={''}
                                                    sessionError={''}     
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox 
                                                    label={"Number of Time Periods"} 
                                                    placeholder={"Enter No.of time periods"}
                                                    id={"no_of_time_period"}
                                                    htmlFor={"no_of_time_period"}
                                                    value={newSubDiv?.no_of_time_period===null?'':newSubDiv?.no_of_time_period}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px]'>
                                            <div className='w-[65%]'>
                                                <Dropdown
                                                    label={"Time Period"}
                                                    id={"time_period"}
                                                    placeholder={'Day(s)'}
                                                    value={newSubDiv?.time_period}
                                                    options={['Day(s)','Week(s)','Month(s)','Calendar Month(s)']}
                                                    emptyField={""}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <h1 className="text-lg font-normal text-[#000000] mb-5">Vital Collection Information</h1>
                                    <div className='flex flex-wrap -mx-[18px]'>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox 
                                                    label={"Number of Readings"} 
                                                    placeholder={"Enter No.of readings"}
                                                    id={"no_of_readings"}
                                                    htmlFor={"no_of_readings"}
                                                    isUnit={true}
                                                    unitType={"Readings"}
                                                    value={newSubDiv?.no_of_readings}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox 
                                                    label={"Number of Time Periods"} 
                                                    placeholder={"Enter No.of time periods"}
                                                    id={"no_of_time_period2"}
                                                    htmlFor={"no_of_time_period"}
                                                    value={newSubDiv?.no_of_time_period2===null?'':newSubDiv?.no_of_time_period2}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px]'>
                                            <div className='w-[65%]'>
                                                <Dropdown
                                                    label={"Time Period"}
                                                    id={"time_period2"}
                                                    placeholder={'Day(s)'}
                                                    value={newSubDiv?.time_period2}
                                                    options={['Day(s)','Week(s)','Month(s)','Calendar Month(s)']}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <h1 className="text-lg font-normal text-[#000000] mb-5">Point Of Contact </h1>
                                    <div className='flex flex-wrap -mx-[18px]'>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox 
                                                    label={"Name"} 
                                                    placeholder={"Enter name"}
                                                    id={"name"}
                                                    htmlFor={"name"}
                                                    value={newSubDiv?.name}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px] mb-5'>
                                            <div className='w-full'>
                                                <InputBox 
                                                    label={"Email Address"} 
                                                    placeholder={"Enter email address"}
                                                    id={"email_addr"}
                                                    htmlFor={"email_addr"}
                                                    value={newSubDiv?.email_addr}
                                                    emailError={submitSelected&&newSubDiv?.email_addr?.trim()!==''&&validateEmail(newSubDiv?.email_addr)}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                                {submitSelected&&newSubDiv?.email_addr?.trim()!==''&&validateEmail(newSubDiv?.email_addr) && <ErrorMessage error  message={"Invalid email address"}/>} 
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px]'>
                                            <div className='w-full'>
                                               
                                                <PhoneNumberValidator
                                                    label={"Main Number"} 
                                                    placeholder={"Enter Main Number"}
                                                    id={"poc_main_number"}
                                                    htmlFor={"Admin_Mobile_Number"}
                                                    value={newSubDiv?.main_number}
                                                    emptyField={false}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                    isCode={true}
                                                    countryCodeList={phoneCodeArray}
                                                    country_code={country_code}
                                                    countryCodeVal={countryCodeVal}
                                                    setCountryCodeVal={setCountryCodeVal}
                                                    isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                                    setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                    submitSelected={submitSelected}
                                                    //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}

                                                />
                                            </div>
                                        </div>
                                        <div className='w-1/3 px-[18px]'>
                                            <div className='w-full'>
                                                
                                                <PhoneNumberValidator
                                                    label={"Mobile Number"}
                                                    placeholder={"Enter Mobile Number"}
                                                    id={"mobile_number"}
                                                    htmlFor={"Admin_Mobile_Number"}
                                                    value={newSubDiv?.mobile_number}
                                                    emptyField={false}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                    isCode={true}
                                                    countryCodeList={phoneCodeArray}
                                                    country_code={country_code}
                                                    countryCodeVal={countryCodeVal2}
                                                    isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                                    setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                    setCountryCodeVal={setCountryCodeVal2}
                                                    submitSelected={submitSelected}
                                                    //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='px-2.5 flex justify-end pt-3'>
                                <UpdateButton 
                                    loading={loading} 
                                    ButtonName={buttonName} 
                                    disabled={loading}
                                    handleOnCLick={handleOnClickEdit}
                                    classKey={'py-2.5 px-4 rounded-[16px] border border-[#972E4C] bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf w-[170px]'}/>
                            </div>
                        </div>
                           
                    </div>
                    {
                        toastErrorMessage!==''&&<Toast
                            message={toastErrorMessage}
                            type='error'
                            setToastmessage={setToastErrorMessage}
                            modal={true}
                            
                        />
                    }
                </div>
             
            }
        />
        
    );
}

export default EditSubDivModal;
